import DateTimeView from './DateTimeView'

export default DateTimeView
